async function unregisterAllServiceWorkers() {
  if (!("serviceWorker" in navigator)) {
    return;
  }
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch (error) {
    console.warn("Service worker cleanup failed:", error);
  }
}

async function clearAppCaches() {
  if (!("caches" in window)) {
    return;
  }
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  } catch (error) {
    console.warn("Cache cleanup failed:", error);
  }
}

export function registerServiceWorker() {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("load", () => {
    unregisterAllServiceWorkers();
    clearAppCaches();
  });
}
